import React from 'react';

import { IMetalGroup } from '../../../../sharedInterfaces';

import MaterialsDesktop from './MaterialsDesktopLUXE';
import MaterialsMobile from './MaterialsMobileLUXE';


interface Props {
  metalGroup:IMetalGroup,
  onMetalGroupChange:(value:IMetalGroup)=>void,
  limitedMaterials:string[],
  assetURI:string,
  mobile:boolean,
  menuHeight:number,
  menuScaleFactor:number
}

interface State {
}


export default class Materials extends React.Component<Props,State> {
  constructor(props: Props) {
    super(props);
  }

  public onParameterChange = (param:'material'|'surface'|'purity', value:any) => {
    // console.log('onParameterChange()', param, value);
    const { metalGroup } = this.props;
    this.props.onMetalGroupChange({
      ...metalGroup,
      [param]: value,
    });
  }

  render = () => {
    const {
      mobile
    } = this.props;

    if (!mobile) {
      return (
        <MaterialsDesktop
          {...this.props}
          onParameterChange={this.onParameterChange}
        />
      )
    } else {
      return (
        <MaterialsMobile
          {...this.props}
          onParameterChange={this.onParameterChange}
        />
      )
    }
  }    
}